import { fleetRecordPath } from '../fleet/fleet-tabs';

/** An owner's own page gives each tab its own route, `/fleet/owners/:id/<tab>` (`recordTabRoutes`). */
export const OWNER_TABS = ['details', 'assets', 'history'] as const;
export type OwnerTab = (typeof OWNER_TABS)[number];

export const OWNER_TAB_LABELS: Record<OwnerTab, string> = { details: 'Details', assets: 'Trucks & trailers', history: 'History' };

export function ownerTabPath(id: string, tab: OwnerTab): string {
  return `${fleetRecordPath('owners', id)}/${tab}`;
}
